import {
  getCurrentSet,
  setTraitPrefixes,
  setUnitPrefixes,
} from "@/game-tft/constants.mjs";

export default function getValidatedSet(set) {
  if (!["string", "number"].some((i) => typeof set === i))
    return getCurrentSet();
  const setString = `set${set}`;
  if (setUnitPrefixes[setString] || setTraitPrefixes[setString])
    return setString;
  return getCurrentSet();
}
